export const MINIMUM_SEARCH_LENGTH = 2
